import { render, staticRenderFns } from "./Pep-statement-notification-assignment-search.vue?vue&type=template&id=5e13b8ee&scoped=true"
import script from "./Pep-statement-notification-assignment-search.vue?vue&type=script&lang=js"
export * from "./Pep-statement-notification-assignment-search.vue?vue&type=script&lang=js"
import style0 from "./Pep-statement-notification-assignment-search.vue?vue&type=style&index=0&id=5e13b8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13b8ee",
  null
  
)

export default component.exports